<template>
  <div class="outer">
    <div :class="[ active ? 'not-visible' : '', 'file' ]" @click="showOptions">
      <span class="fa-stack fa-3x">
        <i class="fa fa-file fa-stack-2x"></i>
        <strong class="fa-stack-1x file-text">{{ extension }}</strong>
      </span>
      <div class="file-name">
        {{ fileName }}
      </div>
    </div>
    <div :class="[ active ? 'visible' : '', 'abs' ]" :style="{ width: buttonBoxWidth + 'px' }">
      <div :class="[ active ? 'visible' : '', 'action' ]">
        <div  class="btn btn-default" @click="active = !active"><i class="fa fa-times"></i></div>
        <div  class="btn btn-primary"><i class="fa fa-download"></i></div>
        <div  class="btn btn-danger" @click="remove"><i class="fa fa-trash-o"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
  import event from '../../../event'
  export default {
    name: 'File',
    props: ['name', 'index'],
    data () {
      return {
        active: false,
        buttonBoxWidth: 0
      }
    },
    computed: {
      extension () {
        return this.extensionRaw.length > 3 ? this.extensionTrimmed : this.extensionRaw
      },
      extensionRaw () {
        return this.name.split('.').pop()
      },
      extensionTrimmed () {
        return this.extensionRaw.substring(0, 3) + '..'
      },
      fileName () {
        return this.name.length > 14 ? this.fileNameTrimmed : this.name
      },
      fileNameTrimmed () {
        return this.name.substring(0, 11) + '...'
      }
    },
    methods: {
      remove () {
        this.$emit('remove-file', { index: this.index })
      },
      showOptions () {
        this.active = true
        this.$emit('showing-file-options', { index: this.index })
      },
      close (data) {
        if (data.index !== this.index) {
          this.active = false
        }
      },
      forceClose (data) {
        this.active = false
      },
      calcButtonBoxWidth () {
        this.buttonBoxWidth = this.$el.clientWidth
      }
    },
    created () {
      this.$parent.$on('close-files', this.close)
      this.$parent.$on('all-close', this.forceClose)
      event.$on('window-resizing', this.calcButtonBoxWidth)
    },
    mounted () {
      this.calcButtonBoxWidth()
    },
    beforeDestroy () {
      this.$parent.$off('close-files', this.close)
      this.$parent.$off('all-close', this.forceClose)
      event.$off('window-resizing', this.calcButtonBoxWidth)
    }
  }
</script>

<style>
  .file-text {
    color: #fff;
    margin-top: 0.9em;
    font-size: 0.4em;
  }
  .file {
    transition: all 0.5s;
    cursor: pointer;
    margin-top:15px;
    z-index:10;
  }
  .file:hover {
    transform: scale(1.05, 1.05);
  }
  .file.not-visible {
    transform: rotateY(180deg);
    opacity: 0.5;
    z-index:0;
  }
  .action {
    transform: rotateY(-90deg);
    transition: transform 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .action.visible {
    transform: rotateY(0deg);
  }
  .action > * {
    margin-bottom:3px;
  }
  .abs {
    position: absolute;
    top:5%;
    z-index:-1;
  }
  .abs.visible {
    z-index:10;
  }
  .outer {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/library/components/File.vue